import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useCallback,
} from "react";
import { getWhatsAppStatusAsync } from "../../services/subcriptionApi";
import { useBillingCompanyContext } from "../../providers/BillingCompanyProvider";
import {
  fetchOrgEnvConfigListService,
  IOrgEnvConfig,
} from "./WhatsappStatusService";

interface IWhatsAppStatusContext {
  whatsappNumber: string;
  loading: boolean;
  error: string | null;
}

const WhatsAppStatusContext = createContext<IWhatsAppStatusContext | undefined>(
  undefined,
);

export const useWhatsAppStatus = () => {
  const context = useContext(WhatsAppStatusContext);
  if (context === undefined) {
    throw new Error(
      "useWhatsAppStatus must be used within a WhatsAppStatusProvider",
    );
  }
  return context;
};

interface IWhatsAppStatusProviderProps {
  children: React.ReactNode;
}

export const WhatsAppStatusProvider: React.FC<IWhatsAppStatusProviderProps> = ({
  children,
}) => {
  const [whatsappNumber, setWhatsappNumber] = useState<string>("");
  const [orgEnvConfigList, setOrgEnvConfigList] = useState<IOrgEnvConfig[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const companyOutlet = useBillingCompanyContext();



  // Fetch org env config to get WhatsApp number

  const fetchOrgEnvConfig = useCallback(async () => {
    if (!companyOutlet.comapny.company_outlet_uuid) return;

    try {
      const data = await fetchOrgEnvConfigListService({
        companyOutletUuid: companyOutlet.comapny.company_outlet_uuid,
        env_key: "WHATSAPP_NUMBER",
      });

      setOrgEnvConfigList(data);
    } catch (err) {
      console.error("Failed to fetch org env config", err);
      setOrgEnvConfigList([]);
    }
  }, [companyOutlet.comapny.company_outlet_uuid]);

  useEffect(() => {
    fetchOrgEnvConfig();
  }, [fetchOrgEnvConfig]);

  // Extract WhatsApp number from environment configuration
  useEffect(() => {
    if (orgEnvConfigList && orgEnvConfigList.length > 0) {
      const whatsappConfig = orgEnvConfigList.find(
        (config) => config.env_key === "WHATSAPP_NUMBER",
      );
      if (whatsappConfig && whatsappConfig.env_value) {
        setWhatsappNumber(whatsappConfig.env_value);
      } else {
        setWhatsappNumber("");
      }
    } else {
      setWhatsappNumber("");
    }
  }, [orgEnvConfigList]);

  // Fetch status when company outlet changes


  const value: IWhatsAppStatusContext = {
    whatsappNumber,
    loading,
    error,
  };

  return (
    <WhatsAppStatusContext.Provider value={value}>
      {children}
    </WhatsAppStatusContext.Provider>
  );
};
